var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.667 7.667a.667.667 0 0 1-1.334 0V5a.667.667 0 0 1 1.334 0v2.667ZM8 10.333A.667.667 0 1 1 8 9a.667.667 0 0 1 0 1.333Zm7.04-.464-5.114-8.48C9.526.728 8.806.333 8 .333c-.807 0-1.527.395-1.926 1.056L.959 9.87a1.984 1.984 0 0 0-.03 2.022C1.315 12.575 2.065 13 2.885 13h10.23c.82 0 1.57-.425 1.955-1.11a1.984 1.984 0 0 0-.03-2.021Z",
    fill: "#F22F22"
  })));
};
export default SvgError;